module.exports = __webpack_public_path__ + "media/images/team/andreas-a8415ee836b8a55390a53aea9c33f625.jpg";